import {api} from './Api';
import {IBlock} from '../models';

export const createBlock = (block: Partial<IBlock>) => {
  return api.post(`block/`, block).then((res: any) => ({
    ...res.data,
    result: {
      ...res.data.result,
      id: res.data.id,
    }
  }));
}

export const createBlocks = (blocks: Partial<IBlock>[]) => {
  /*
   * TODO - create endpoint on the BE for this
   */
  return Promise.all(blocks.map(createBlock)).then((res: any) => res.map((r: any) => r.result))
}

export const updateBlock = (uid: string, block: Partial<IBlock>) => {
  return api.put(`block/${uid}`, block).then((res: any) => res.data);
}

export const updateBlocks = (blocks: Partial<IBlock>[]) => {
  return api.put(`block/bulk/update`, blocks).then((res: any) => res.data);
}

export const deleteBlock = (uid: string) => {
  return api.delete(`block/${uid}`).then((res: any) => res.data);
}

export const getBlockResult = (uid: string, resultId: string) => {
  return api.get(`/block/${uid}/results/${resultId}`).then((res: any) => res.data);
}

export const getBlockResults = (uid: string) => {
  return api.get(`/block/${uid}/results/`)
    .then((res: any) => ({
      uid,
      ...res.data
    }))
    .then((data: any) => {
      if (data.result && data.result.length > 0) {
        return getBlockResult(uid, data.result[0].key)
          .then((resultData: any) => {
            const lastResult = resultData.result;
            return {
              uid: data.uid,
              result: data.result.map((r: any) => r.key === lastResult.key ? lastResult : r)
            };
          });
      }
      return data;
    });
}

export const executeBlock = (
  uid: string,
  reportUid: string | null | undefined = null,
  block: Partial<IBlock>
) => {
  const payload = block ? {
    content_json: JSON.stringify(block.content_json)
  } : {};
  let url = `/block/${uid}/run`;

  if (reportUid) {
    url = `/block/${uid}/run/${reportUid}`;
  }

  return api.post(url, payload).then((res: any) => res.data);
}

export const stopBlockExecution = (uid: string, resultId: string) => {
  return api.get(`/block/${uid}/stop/${resultId}`).then((res: any) => res.data);
}

export const previewBlock = (
  uid: string,
  reportUid: string | null | undefined = null,
) => {
  return api
    .get(`/block/${uid}/preview/${reportUid}`)
    .then((res: any) => res.data);
};
